document.addEventListener("DOMContentLoaded", () => {
  // Use event delegation by attaching the click event to a parent element that is always present
  function updateProductCardMedia(event) {
    let swatch = event.target.closest(".card__swatches-each");
    if (swatch) {
      // Fetch the value of data-varimage, data-varsrcset, and data-variant-url
      const varImage = swatch.dataset.varimage;

      const varImageSet = swatch.dataset.varsrcset;
      const varSecImage = swatch.dataset.varsecimage;
      const varSecImageSrcset = swatch.dataset.varsecimageSrcset;
      const variantUrl = swatch.dataset.variantUrl;

      // Find the nearest parent with the class '.product-card-wrapper'
      let parent = swatch.closest(".product-card-wrapper");

      if (parent) {
        // Find the child '.card__media' within that parent
        let cardMedia = parent.querySelector(".card__media");
        let cardInner = parent.querySelector(".card__inner");

        if (cardMedia) {
          // Find the first image within '.card__media' and replace its src and srcset
          let Media = parent.querySelector(".media");
          let firstImage = Media.querySelector(".var-first-image");
          let secImage = Media.querySelector(".var-sec-image");

          if (firstImage) {
            firstImage.src = varImage;
            firstImage.srcset = varImageSet;
          }
          if (secImage) {
            secImage.src = varSecImage;
            secImage.srcset = varSecImageSrcset;
          }

          if (cardInner) {
            cardInner.setAttribute(
                "onclick",
                `goToProduct('${variantUrl}', 1)`
            );
          }
        }
      }
    }
  }

  document.body.addEventListener("click", updateProductCardMedia);
  if(document.body.classList.contains('template-collection')){
    document.body.addEventListener("mouseover", updateProductCardMedia);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Function to open the modal
  function openModal(modalContent) {
    document.querySelector(".c-modal-overlay").classList.add("active");
    modalContent.classList.add("active");
  }

  // Function to close the modal
  function closeModal(modalContent) {
    modalContent.classList.remove("active");
    document.querySelector(".c-modal-overlay").classList.remove("active");
  }

  // Event delegation for opening the modal
  document.body.addEventListener("click", function (event) {
    const target = event.target.closest("[data-info-popup-btn]");
    if (target) {
      const modalTarget = target.getAttribute("data-modal-target");
      const modalContent = document.querySelector('[data-modal-content="' + modalTarget + '"]');
      if (modalContent) {
        openModal(modalContent);
      }
      event.preventDefault();
    }
  });

  // Event delegation for closing the modal
  document.body.addEventListener("click", function (event) {
    if (event.target.matches("[data-modal-close]") || event.target.closest(".c-modal-overlay")) {
      event.preventDefault();
      const modalContent = document.querySelector('[data-modal-content].active');
      if (modalContent) {
        closeModal(modalContent);
      }
    }
  });
});

const search_input = document.querySelector("#Search-In-Modal");
const search_div = document.querySelector("#search-div");

search_input.addEventListener('input', () => {
  if (search_input.value) {
    search_div.style.display = 'none';
  } else {
    search_div.style.display = 'block';
  }
})

document.addEventListener('DOMContentLoaded', () => {
  // Select elements
  const modal = document.querySelector('#myModal'); // Modal element
  const closeModalBtn = document.querySelector('.close'); // Close button inside modal
  const html = document.documentElement; // Select the <html> element

  // Open modal
  function openModal() {
    modal.classList.add('open');
    html.style.overflow = 'hidden'; // Disable scrolling on <html>
    html.style.height = '100%'; // Ensure proper height handling
  }

  // Close modal
  function closeModal() {
    modal.classList.remove('open');
    html.style.overflow = ''; // Re-enable scrolling on <html>
    html.style.height = ''; // Reset height
  }

  // Close modal when clicking outside modal content
  if (modal) {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal();
      }
    });
  }

  // Close modal when clicking the close button
  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeModal);
  }
});


function initCustomSelect() {
  const selectEl = document.querySelector('.js-custom-select');
  if (!selectEl) return;

  const existingWrapper = selectEl.parentNode.querySelector('.custom-select-wrapper');
  if (existingWrapper) {
    return;
  }

  selectEl.style.display = 'none';

  const wrapper = document.createElement('div');
  wrapper.className = 'custom-select-wrapper';

  selectEl.parentNode.insertBefore(wrapper, selectEl.nextSibling);

  const styledSelect = document.createElement('div');
  styledSelect.className = 'custom-select-styled';
  styledSelect.textContent = selectEl.options[selectEl.selectedIndex].textContent;
  wrapper.appendChild(styledSelect);

  const dropdown = document.createElement('ul');
  dropdown.className = 'custom-select-dropdown';
  dropdown.style.display = 'none';
  wrapper.appendChild(dropdown);

  Array.from(selectEl.options).forEach((optionEl, index) => {
    const li = document.createElement('li');
    li.textContent = optionEl.textContent;
    li.dataset.value = optionEl.value;
    dropdown.appendChild(li);

    if (optionEl.selected) {
      li.classList.add('is-selected');
    }

    li.addEventListener('click', function() {
      selectEl.selectedIndex = index;

      const changeEvent = new Event('input', {bubbles: true});
      const submitEvent = new Event('submit', {bubbles: true});
      selectEl.dispatchEvent(changeEvent);
      document.querySelector('#FacetSortDrawerForm').dispatchEvent(submitEvent);

      styledSelect.textContent = optionEl.textContent;
      dropdown.querySelectorAll('li').forEach((x) => x.classList.remove('is-selected'));
      li.classList.add('is-selected');
      dropdown.style.display = 'none';
    });
  });

  const triggers = document.querySelectorAll('.js-caret, .facet-filters__field label');

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
      if (trigger.tagName.toLowerCase() === 'label') {
        e.preventDefault();
      }

      e.stopPropagation();
      if (dropdown.style.display === 'none') {
        closeAllCustomSelects();
        dropdown.style.display = 'block';
      } else {
        dropdown.style.display = 'none';
      }
    });
  });

  document.addEventListener('click', closeAllCustomSelects);

  function closeAllCustomSelects() {
    const allDropdowns = document.querySelectorAll('.custom-select-dropdown');
    allDropdowns.forEach(function(dd) {
      dd.style.display = 'none';
    });
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initCustomSelect();
});
const container = document.querySelector('#ProductGridContainer')
    || document.querySelector('main');

if (container) {
  const observer = new MutationObserver((mutations) => {
    initCustomSelect();
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    characterData: false,
  });
}

document.querySelectorAll('.mega-menu__link').forEach(link => {
  if (link.getAttribute('href') === '#') {
    link.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent the default action
    });

    // Optionally, you can also add a class to indicate it's not clickable
    link.classList.add('disabled-link');
  }
});

